import JsonView from 'react-json-view'
import { styled, useTheme } from 'styled-components'
import _ from 'lodash'

import color from 'peach/helpers/color/color'

import JsonValue from './JsonValue'

const Wrapper = styled.div`
  padding: 8px;
  font-size: 12px;

  & * {
    line-height: 1.3;
  }
`

type JsonProps = {
  name?: string
  json: any
  type?: string
  jsonKey?: string
  collapsed?: boolean
}

const Json = ({ name, json, type, jsonKey, collapsed, ...rest }: JsonProps) => {
  const { background } = useTheme()

  const isLight = color.isLight(background)

  return (
    <Wrapper>
      {!_.isObject(json) || _.isEmpty(json) ? (
        <JsonValue jsonKey={jsonKey} type={type} value={json} />
      ) : (
        <JsonView
          collapseStringsAfterLength={50}
          collapsed={collapsed ?? 4}
          displayDataTypes={false}
          enableClipboard={false}
          indentWidth={4}
          name={name || false}
          src={json}
          theme={isLight ? 'rjv-default' : 'monokai'}
          {...rest}
        />
      )}
    </Wrapper>
  )
}

export default Json
